import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { startVkAuth } from "../../platform/social/vk";
import { parseBridgeParams, isValidNonce } from "../../api/authBridge";
import "./TelegramAuthBridge.css";

// Rendered in the SYSTEM BROWSER (not Telegram) when the web app is opened with
// ?tgauth=<nonce>. Runs VK login in the normal browser, then hands the session
// to the server keyed by the nonce so the waiting Mini App can redeem it.
const TelegramAuthBridge: React.FC = () => {
  const { t } = useTranslation();
  const { nonce, provider } = parseBridgeParams();
  const [error, setError] = useState<string | null>(null);

  const validLink = isValidNonce(nonce) && provider === "vk";

  return (
    <div className="tg-bridge">
      <div className="tg-bridge-card">
        {!validLink ? (
          <p data-testid="bridge-invalid">{t("auth.bridgeInvalidLink")}</p>
        ) : (
          <>
            <h2>{t("auth.bridgeSignInTitle")}</h2>
            {error && <div className="auth-error">{error}</div>}
            <button
              type="button"
              className="social-auth-btn social-auth-btn--vk"
              data-testid="vk-continue"
              onClick={() => {
                startVkAuth({ mode: "login", bridgeNonce: nonce }).catch((e: any) =>
                  setError(e?.message || t("auth.vkFailed"))
                );
              }}
            >
              <img
                className="social-auth-btn__icon"
                src={`${process.env.PUBLIC_URL}/images/vk_flat.png`}
                alt=""
                aria-hidden="true"
              />
              <span className="social-auth-btn__label">
                {t("auth.continueWithVk")}
              </span>
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default TelegramAuthBridge;
